<app-offline-banner></app-offline-banner>
<app-header></app-header>
<main>
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
<app-cookie-consent></app-cookie-consent>
<app-ai-assistant></app-ai-assistant>
